var Entities = require('Entities');
var Logger = require('Logger');
var Lookups = EY.Consultation.Lookups;

var index = function (options) {
    options.formData.append('id', options.id);
    options.formData.append('key', 'global');
    new Entities.Solr().save({ documentId: options.id }, {
        contentType: false,
        processData: false,
        data: options.formData
    }).done(function () {
        Logger.log('Attachment indexed');
    });
};

var remove = function (options) {
    new Entities.Solr({ id: options.id }).destroy().done(function () {
        Logger.log('Solr Index deleted');
    });
};

var update = function (attachment) {
    var request = new XMLHttpRequest();
    request.open("GET", attachment.url() + '?zone=' + attachment.get('zone') + '&name=' + attachment.get('filename') + '&token=' + Lookups.Azure.Token, true);
    request.responseType = "blob";

    request.onload = function () {
        var form = new FormData();
        form.append('file', request.response);
        index({ id: attachment.id, formData: form });
    };
    request.send();
};

module.exports = {
    index: index,
    delete: remove,
    update: update
};


// WEBPACK FOOTER //
// ./js/Modules/Service/Solr.js